import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.587 284.572a.529.528 0 0 0-.369.906l6.871 6.87a.529.528 0 0 0 .748 0l6.871-6.87a.529.528 0 1 0-.747-.747l-6.499 6.497-6.497-6.497a.529.528 0 0 0-.378-.16",
      style: {"transform-origin":"8.46662px 288.533px"},
      transform: "rotate(179.98 120.767 -19.267)scale(33.74584)"
    }, null, -1)
  ])))
}
export default { render: render }